export default {
  getDmsData: (state) => state.dmsData,
};
